module.exports = __webpack_public_path__ + "img/pro-manage2.0f8bdce3.png";